import styled from "@emotion/styled";

export const WrapperSlider = styled.div`
  margin-top: 28px;
  margin-bottom: 30px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    margin-top: 40px;
    margin-bottom: 22px;
  }
`;
